import React, { Component } from 'react';
import MainNav from './components/Navigation/MainNav';
import Hero from './components/Hero/Hero';
import Footer from './components/Footer/Footer';
import Home from './components/pages/Home';
import Products from './components/pages/Products';
import Product from './components/pages/Product';
import About from './components/pages/About';
import Support from './components/pages/Support';
import News from './components/pages/News';
import Contact from './components/pages/Contact';
import NotFound from './components/pages/NotFound';
import GetSDS from './components/pages/GetSDS';
import SdsDownload from './components/pages/SdsDownload';
import Sectors from './components/pages/Sectors';
import URI from  './constants/serverUrl';
import sectorStore, { getSectors, setSectors } from './stores/sectorsStore';
import SdsSearchTable from './components/SDSSearchTable/SDSSearchTable';
import MobileNav from './components/MobileNav';
import { Route, NavLink, Switch } from 'react-router-dom';
import { withRouter } from 'react-router';
import reqeust from 'superagent';
import './App.css';
import './Main.css';


class App extends Component {

  constructor() {
    super()
    reqeust.get(URI + '/public_products/')
      .set('ngrok-skip-browser-warning', true)
      .end((err, res) => {
        if (err || !res || !res.text) {
          this.setState({ serverError: true });
          return;
        }
        let data;
        try {
          data = JSON.parse(res.text);
        } catch (e) {
          this.setState({ serverError: true });
          return;
        }
        const categories = data.categories;
        const markets = data.markets;
        data.products = data.products.map(p => {
          const c = p.productCategory.length && p.productCategory.map(ci => {
            return categories.find(ca => ca.id == ci);
          });
          const m = p.markets && p.markets.map(m => {
           return markets.find(ma => ma.id == m);
          });
          return {
            ...p,
            _categories: c,
            _markets: m,
          }
        });
        const c = {};
        data.configs.forEach(co => c[co.name] = co.val)
        sectorStore.dispatch(setSectors(data.sectors));
        this.setState({data, loaded: true});
      });
  }

  withConfigs(Component) {
    return (matchProps) => {
      return <Component configs={ this.state.data.configs } {...matchProps} />
    }
  }

  changePage = (url) => {
    this.props.history.push(url);
  }

  state = {
    data: {
      posts: [],
      products: [],
      categories: [],
      markets: [],
      configs: {},
      sizes: [],
      sectors: [],
      news_posts: [],
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', () => {
      console.log('scrolling');
        // Parallax effect
        const layers = document.querySelectorAll('.parallax-layer');
        const scrollY = window.scrollY;
    
        layers.forEach((layer, index) => {
          const depth = (index + 1) * 5; // You can tweak this for subtlety
          const movement = scrollY * (depth / 100); // Very gentle
          layer.style.transform = `translateY(${movement}px)`;
        });
      });
  }

  search = (value) => {
    const { products, categories, markets } = this.state.data;
    const product = products.find(p => p.name === value)
    if(product) {
      return this.changePage('/product/' + product.id);
    }
    const category = categories.find(p => p.name === value)
    if(category) {
      return this.changePage('/our_products/' + category.id);
    }
    const market = markets.find(p => p.name === value)
    if(market) {
      return this.changePage('/our_markets/' + market.id);
    }
  }

  autoCompleteChoices() {
    const { products, categories, markets } = this.state.data;
    return [...products.map(p=>p.name), ...categories.map(p => p.name), ...markets.map(m => m.name)];
  }

  renderHome() {
    return <Home posts={this.state.data.posts} />
  }

  renderProducts = (match) => {
    return <Products
      products={this.state.data.products}
      categories={this.state.data.categories}
      category={match.match.params.category_id}
      market={match.match.params.market_id}
      markets={this.state.data.markets}
      subCategory_id={match.match.params.subCategory_id}
    />
  }

  renderMarkets = (match) => {
    return <Products
      products={this.state.data.products}
      categories={[]}
      category={'all'}
      market={match.match.params.market_id}
      markets={this.state.data.markets}
    />
  }

  renderProduct = (match) => {
    const product = this.state.data.products.find(p => p.id == match.match.params.product_id);
    return product ? <Product product={product} categories={this.state.data.categories} sizes={this.state.data.sizes} /> : this.renderProducts(match);
  }

  renderAbout = (match) => {
    return <About posts={this.state.data.posts} products={this.state.data.products} />
  }

  renderSupport = (match) => {
    return <Support posts={this.state.data.posts.filter(p => p.page === 'Support')} post={match.match.params.post} />
  }

  renderNews = (match) => {
    return <News posts={this.state.data.news_posts} post={match.match.params.post} />
  }

  renderPost = (match) => {
    const postId = match.match.params.post;
    const post = this.state.data.posts.find(p => p.id == postId);
    if (!post) {
      return <News posts={[]} post={postId} />
    }
    return <News posts={[post]} post={postId} />
  }

  renderContact = (match) => {
    const product = this.state.data.products.find(p => p.id == match.match.params.product_id);
    let contactMessage = product && product.name || '';
    let productId = product && product.id || undefined;
    return <Contact configs={ this.state.data.configs } message={ contactMessage } product={productId} />
  }

  renderSDS = (match) => {
    const productId = match.match.params.product_id;
    const product = this.state.data.products.find(p => p.id == productId);
    const productName = product && product.name || undefined;
    return <GetSDS configs={ this.state.data.configs } productName={ productName } productId={ productId } />
  }

  renderSector = (match) => {
    const sectorId = match.match.params.sector_id;
    // You'll need to add sectors to your state.data and fetch them from the API
    const sector = this.state.data.sectors && this.state.data.sectors.find(s => s.id == sectorId);
    return <Sectors sector={sector} />
  }

  renderSearch = (match) => {
    return <SdsSearchTable products={this.state.data.products} />
  }

  render() {
    const isHome = window.location.pathname === '/';

    if (this.state.serverError) {
      return (
        <div className="server-error-page">
          <div className="server-error-card">
            <div className="server-error-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#5a2684"/>
              </svg>
            </div>
            <h1 className="server-error-title">Unable to connect</h1>
            <p className="server-error-message">
              We could not reach <strong>geller.co.nz</strong> — it may be temporarily unavailable.<br />
              Please check your internet connection and try again in a few minutes.
            </p>
            <button className="server-error-button" onClick={() => window.location.reload()}>
              Try again
            </button>
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <MobileNav />
        <MainNav 
          markets={this.state.data.markets} 
          changePage={this.changePage} 
          categories={this.state.data.categories} 
          search={this.search} 
          choices={this.autoCompleteChoices()} 
        />
        <Switch>
          <Route exact={true} path="/" render={(match) => this.renderHome()} key={1} />
          <Route exact={true} path="/our_products/:category_id" render={(m) => this.renderProducts(m)} key={2} />
          <Route exact={true} path="/our_products/:category_id/:subCategory_id" render={(m) => this.renderProducts(m)} key={59} />
          <Route exact={true} path="/product/:product_id" render={(m) => this.renderProduct(m)} key={3} />
          <Route exact={true} path="/product/:product_id/:market_id" render={(m) => this.renderProduct(m)} key={3006} />
          <Route exact={true} path="/our_markets/:market_id" render={(m) => this.renderMarkets(m)} key={300} />
          <Route exact={true} path="/our_markets" render={(m) => this.renderMarkets(m)} key={30009} />
          <Route exact={true} path="/sectors/:sector_id" render={(m) => this.renderSector(m)} key={600} />
          <Route exact={true} path="/sectors" render={(m) => this.renderSector(m)} key={601} />
          <Route exact={true} path="/about/:post" render={(m) => this.renderAbout(m)} key={4} />
          <Route exact={true} path="/about" render={(m) => this.renderAbout(m)} key={42} />
          <Route exact={true} path="/news" render={(m) => this.renderNews(m)} key={49} />
          <Route exact={true} path="/news/:post" render={(m) => this.renderNews(m)} key={9} />
          <Route exact={true} path="/news-post/:post" render={(m) => this.renderPost(m)} key={8} />
          <Route exact={true} path="/support/:post" render={(m) => this.renderSupport(m)} key={10} />
          <Route exact={true} path="/support" render={(m) => this.renderSupport(m)} key={11} />
          <Route exact={true} path="/contact" render={(m) => this.renderContact(m)} key={12} />
          <Route exact={true} path="/contact/:product_id" render={(m) => this.renderContact(m)} key={19} />
          <Route exact={true} path="/getsds/:product_id" render={(m) => this.renderSDS(m)} key={501} />
          <Route exact={true} path="/sds-download" render={() => <SdsDownload />} key={503} />
          <Route exact={true} path="/search" render={(m) => this.renderSearch(m)} key={502} />
          <Route exact={true} path="/privacy-policy" render={() => { window.location.replace('/privacy-policy.html'); return null; }} key={504} />
          <Route component={this.withConfigs(NotFound)} />
        </Switch>
        <div className="container">
          <Footer configs={this.state.data.configs} />
        </div>
        
        {!this.state.loaded && (
          <div className="loading-overlay" />
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// src/App.js